import { useEffect, useState } from "react";
import { getAttachments, getAttachmentsRetry, getKnowledgeArticle } from "../../../utils/AWSAPI";
import LoadingSpinner from "../../../utils/LoadingSpinner";
import '../../../assets/css/KBArticle.css'
import { useTranslation } from 'react-i18next'; 
import i18n from "../../Translations/i18n/i18n";  //import i18next
import DOMPurify from "dompurify";
import { getFileFromBase64 } from "../../../utils/Utils";


function KBArticle() {
  // DATA API
  const [isLoading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [attachments, setAttachments] = useState(null);
  const [articleContent, setArticleContent] = useState("");

  // Are we showing a modal? I.E: Error, success.
  const [isModalShowing, setModalShowing] = useState(false);
  const [isModalUncloseable, setModalUncloseable] = useState(false);

  const { t } = useTranslation();
  
  const [modalHeader, setModalHeader] = useState('Loading...');
  const [modalBody, setModalBody] = useState(<></>);
  const [modalFooter, setModalFooter] = useState(<></>);


  const closeModal = () => {
    setModalShowing(false);
  };

  const Modal = () => {
    return (
      <form>
        <div className="modal show">
          <div className="modal-content">
            <div className="modal-header">
              <h4>{modalHeader}</h4>
              {!isModalUncloseable && (
                <span className="close" onClick={closeModal}>&times;</span>
              )}
            </div>
            <div className="modal-body">{modalBody}</div>
            <div className="modal-footer">{modalFooter}</div>
          </div>
        </div>
      </form>
    );
  };

  const updateModal = (header, body, footer) => {
    setModalShowing(!isModalShowing);
    setModalHeader(header);
    setModalBody(body);
    setModalFooter(footer);
  }
  
  const setDefaultAttributes = async () => {
    const url = new URL(window.location.href);
    const articleValue = url.searchParams.get('articleId');

    setModalFooter(<></>)

    if (!articleValue) {
      updateModal(t('whoops'), t('invalidArticle'));
      return { success: false };
    } else {
      return { success: true, article: articleValue };
    }
  };

  useEffect(() => {
    const loadLanguage = () => {
      const language = localStorage.getItem("language");
      if (language) {
        i18n.changeLanguage(language);
      }
    };
    loadLanguage();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { success, article: fetchedArticle } = await setDefaultAttributes();
        if (success) {
          const articleData = await getKnowledgeArticle(fetchedArticle, localStorage.getItem("language"));
          if (articleData.Error) {
            return updateModal("Error", articleData.Error);
          }
          setData(articleData);
          
          let sanitizedContent = DOMPurify.sanitize(articleData.article);
          console.log("Retrieving attachments for article " + fetchedArticle);

          let parser = new DOMParser();
          let doc = parser.parseFromString(sanitizedContent, 'text/html');
          let imgTags = doc.getElementsByTagName('img');

          let sys_id = "";

          if (imgTags.length > 0) {
            let firstSrc = imgTags[0].getAttribute('src');
            let startIndex = firstSrc.indexOf('sys_id=');
            if (startIndex !== -1) {
                sys_id = firstSrc.substring(startIndex + 7);
                let i = sys_id.indexOf('&');
                if (i !== -1) {
                    sys_id = sys_id.slice(0, i);
                }
            } else {
                console.log('sys_id not found in the src attribute of the first img tag');
            }
          } else {
              console.log('No img tags found in the sanitized HTML content');
          }

          console.log("First sys ID: " + sys_id);
          const attachmentData = await getAttachmentsRetry(fetchedArticle, sys_id);
          if(attachmentData.Error) {
            console.log("Couldn't retrieve attachments for article " + fetchedArticle);
          } else {
            setAttachments(attachmentData);
  
            attachmentData.forEach(async (attachment) => {
              const file = getFileFromBase64(attachment.base64EncodedData, attachment.file_name, attachment.content_type);
              const imageUrl = URL.createObjectURL(file);
              const imgRegex = new RegExp(`<img[^>]*src=["'].*?${attachment.sys_id}.*?["'][^>]*>`, 'g');
  
              sanitizedContent = sanitizedContent.replace(imgRegex, (match) => {
                const imgTag = `<img src="${imageUrl}" />`;
                return imgTag;
              });
            });
  
            console.log("Sanitized attachments.")
          }
          
          setArticleContent(sanitizedContent);
          setLoading(false);
  
        } else {
          console.log("Invalid article. Not calling API.");
        }
      } catch (err) {
        console.log(err);
      }
    };
    
    if (isLoading) {
      fetchData();
    }
  }, [isLoading]);  

  return (
    <div className="App">
      <LoadingSpinner show={isLoading} />
  
      {!isLoading && isModalShowing && (
        <Modal />
      )}
  
      {data && articleContent && (
        <div className="article-container">
          <div className="article-title-box">
            <h1 className="article-title">{data.short_description}</h1>
            <p className="article-number">{data.number}</p>
          </div>
          <div className="article-content-box">
            <div className="article-content" dangerouslySetInnerHTML={{ __html: articleContent }} />
          </div>
        </div>
      )}
    </div>
  )  
}

export default KBArticle;